import { FC, ReactElement, JSX, useCallback } from 'react';
import { useParams } from 'react-router';

import { ContainerColorVariants } from '@beeline/design-system-react/types/components/Banner/Banner.types';
import { InjectedModule } from '@beeline/lk-utils';

import { ErrorBoundary } from '../ErrorBoundary';

import styles from './styles.module.scss';

import { useServicesApi } from ':api/common/useServicesApi';
import { Preloader } from ':components';
import { ServiceBanner } from ':components/ServiceBanner';
import { IS_DEBUG } from ':constants';
import { useServiceId } from ':hooks';

interface Props {
  progress?: JSX.Element;
  element?: () => ReactElement;
  host_url: string;
  component_id: string;
}

export const ExternalModule: FC<Props> = ({
  element,
  host_url,
  component_id,
  progress = <Preloader text='Загрузка сервиса...' />,
}) => {
  const params = useParams();

  const mode = IS_DEBUG ? 'open' : 'closed';

  const errorElement = useCallback(() => <ErrorBoundary />, []);

  const url = useServiceId();

  const { data } = useServicesApi(url);

  const getColor = (): ContainerColorVariants => {
    if (data?.banner?.type === 'warn') return 'warning';
    if (data?.banner?.type === 'info') return 'info';
    if (data?.banner?.type === 'error') return 'error';

    return 'info';
  };

  const color = getColor();
  const showBanner = Boolean(data?.banner?.description);

  return (
    <>
      {showBanner && (
        <ServiceBanner description={data?.banner?.description} color={color} />
      )}
      <InjectedModule
        key={host_url + component_id}
        className={styles.ExternalModuleContainer}
        containerStyle={{ height: '100%' }}
        fallback={progress}
        props={{ location, params, element }}
        mode={mode}
        errorElement={errorElement}
        host={host_url}
        name={component_id}
      />
    </>
  );
};
